import { AutocompleteArrayInput, AutocompleteArrayInputProps, useTranslate } from 'react-admin';
import { InputLabel, OutlinedInputProps } from '@mui/material';

export const GrayAutocompleteArrayInputWithUpperLabel = (props: AutocompleteArrayInputProps & { isRequired?: boolean }) => {

  const translate = useTranslate();

  return (
    <>
      {props.label !== false && (
        <InputLabel className="input-label" required={props.isRequired}>
          {translate(typeof props.label === 'string' ? props.label : '', { _: props.label })}
        </InputLabel>
      )}
      <AutocompleteArrayInput
        {...props}
        className={props.className ? `${props.className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        TextFieldProps={{
          ...props.TextFieldProps,
          InputProps: {
            ...props.TextFieldProps?.InputProps,
            notched: false,
          } as OutlinedInputProps,
        }} componentsProps={{
          ...props.componentsProps,
          paper: {
            ...props.componentsProps?.paper,
            sx: {
              boxShadow: '0 2px 8px 4px lightgray',
              ...props.componentsProps?.paper?.sx,
            },
          },
        }} sx={props.sx}/>
    </>
  );

};
